import type { Snack_SnackEditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useCreateSnackEditorBaseModel } from "../../../../_shared/model/use-create-snack-editor-base-model";

import type { SnackFormModelType } from "../../../../create-new-item/model/usecase/use-create-snack-form-model";

type Props = {
	hotelID: string;
	data: Snack_SnackEditPageQuery;

	snackFormModel: SnackFormModelType;
};

export const useCreateSnackModel = ({ hotelID, data, snackFormModel }: Props) => {
	const {
		planList,
		roomList,
		snackList,
		snack,
		snackListParentTemplate,
		snackListSystemTemplate,
		snackTemplateSystem,
		hotel,
	} = data;

	return {
		...useCreateSnackEditorBaseModel({
			hotelID,

			snackFormModel,

			editorBaseProps: {
				planList,
				roomList,
				snackListParentTemplate,
				snackListSystemTemplate,
				snackTemplateSystem,
				targetSnackItem: {
					isNew: false,
					snack: snack.snack,
					uuid: snack.uuid,
				},
			},

			snackList,

			hotel,
		}),
	};
};
